<template>
  <div
    class="dialog-mask animated fadeIn dialog-agenda-mask" v-if="showSpeakersModal"
  >
    <div class="dialog-modal" :style="{ top: scrollTop + clientHeight / 2  + 'px' }">
      <div class="dialog-close" @click="closeModal">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/forum-close.png" alt="" />
      </div>
      <div class="dialog-content">
        <div class="dialog-content-guest">
          <div class="slide">
            <img
              id="guest-avatar"
              :src="guestDetail.img || guestDetail.photoImgUrl"
              alt=""
            />
          </div> 
          <div class="speaker-info">
            <div class="name" id="guest-name">{{guestDetail['name'+En]}}</div>
            <div class="work" id="guest-work">
            {{ guestDetail["company" + En] }} {{guestDetail['position'+En]}}
            </div>
            <div class="intro" id="guest-content">
              <p>
                <span>{{guestDetail['introduce'+En]}}</span
                >
              </p>
            </div>
          </div>
          <div class="richeng">
            <div class="meeting-title">
              <i18n path="canyuluntan" tag="div">
              </i18n>
            </div>
            <div class="richeng-list">
              <div class="richeng-item" v-for="(item, index) in guestDetail.forumList" :key="index">
                <span>{{ item.dateTime }}</span><big><span class="ellipsis1">{{ item['name' + En] }}</span><span class="ellipsis1">{{ item['addr' + En] }}</span></big>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showSpeakersModal: {
      type: Boolean,
      default: false,
    },
    guestDetail:{
      type:Object,
    }
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("update:showSpeakersModal", false);
      this.$emit("closeModal");
    },
  },
};
</script>
<style lang='less' scoped>
@media screen and (min-width: 769px) {
  .dialog-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 3000;
    .dialog-modal {
      position: fixed;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: #EDEDED;
      border-radius: .16rem;
    }
    .dialog-content {
      position: relative;
      width: 10rem;
      height: 70vh;
      padding: 1.4rem .4rem .34rem;

      .dialog-content-guest {
        height: 100%;
        overflow: auto;

        &::-webkit-scrollbar {
          display: none;
        }
        
        .slide {
          
          img {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -1rem;
            width: 2.2rem;
            height: 2.2rem;
            border-radius: 50%;
            border: .1rem solid RGBA(243, 243, 243, 1);
            object-fit: cover;
            background: RGBA(243, 243, 243, 1);
          }
        }
        .speaker-info {
          text-align: center;
          width: 100%;
          .name {
            font-size: .26rem;
            line-height: 1;
            color: #343434;
            font-family: sybold;
          }
          .work {
            font-size: .2rem;
            line-height: 1;
            width: 100%;
            color: #737373;
            margin: .08rem 0 .2rem;
          }
          .intro {
            font-size: .2rem;
            line-height: .28rem;
            color: #343434;
            text-align: left;
          }
        }

        .richeng {
          margin-top: .4rem;

          .meeting-title {
            font-size: .28rem;
            font-weight: bold;
            color: #3E3A39;
            text-align: left;
          }

          .richeng-list {
            margin-top: .38rem;
            position: relative;

            .richeng-item {
              font-size: .18rem;
              color: #736B69;
              display: flex;
              align-items: center;
              line-height: 1;
              margin-bottom: .28rem;
              padding-left: .16rem;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: .08rem;
                height: .08rem;
                border-radius: 50%;
                background: #B3B3B3;
              }

              &::after {
                content: "";
                position: absolute;
                left: .03rem;
                top: .2rem;
                width: .02rem;
                height: .8rem;
                background: #B3B3B3;
              }

              &:last-of-type::after {
                display: none;
              }

              span {
                margin-right: .16rem;
              }

              big {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: .18rem;
                line-height: 1.3;
                color: #403C3B;
                font-family: sybold;
                flex: 1;
                background: linear-gradient(to right, RGBA(219, 227, 237, 1) 0%, RGBA(225, 221, 237, 1) 100%);
                padding: 0 .42rem 0 .2rem;
                border-radius: .04rem;
                height: .48rem;

                span {
                  &:first-child {
                    max-width: calc(100% - 2rem);
                    overflow: hidden;
                    margin-right: .2rem;
                  }
                }

                span {
                  &:last-child {
                    flex: 1;
                    overflow: hidden;
                    margin-right: 0;
                    text-align: right;
                    color: #736B69;
                  }
                }
              }
            }
          }
        }
      }
    }
    .dialog-close {
      position: absolute;
      top: -0.44rem;
      right: -0.44rem;
      width: .54rem;
      height: .54rem;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .dialog-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 3000;
    .dialog-modal {
      position: fixed;
      left: .2rem;
      top: 2.5rem;
      bottom: 2.24rem;
      width: 7.1rem;
      padding: .36rem .28rem .24rem;
      box-sizing: border-box;
      background: #EDEDED;
      border-radius: .16rem;
    }

    .dialog-content {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 1.4rem .4rem .34rem;

      .dialog-content-guest {
        height: 100%;
        overflow: auto;
        
        .slide {
          
          img {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -1rem;
            width: 2.2rem;
            height: 2.2rem;
            border-radius: 50%;
            border: .1rem solid RGBA(243, 243, 243, 1);
            object-fit: cover;
            background: RGBA(243, 243, 243, 1);
          }
        }
        .speaker-info {
          text-align: center;
          width: 100%;
          .name {
            font-size: .32rem;
            line-height: 1;
            color: #343434;
            font-family: sybold;
          }
          .work {
            font-size: .24rem;
            line-height: 1;
            width: 100%;
            color: #737373;
            margin: .12rem 0 .28rem;
          }
          .intro {
            font-size: .26rem;
            line-height: .38rem;
            color: #343434;
            text-align: left;
          }
        }

        .richeng {
          margin-top: .4rem;

          .meeting-title {
            font-size: .28rem;
            font-weight: bold;
            color: #3E3A39;
            text-align: left;
          }

          .richeng-list {
            margin-top: .38rem;
            position: relative;

            .richeng-item {
              font-size: .26rem;
              color: #736B69;
              line-height: 1;
              margin-bottom: .28rem;
              padding-left: .2rem;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                left: 0;
                top: .09rem;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #B3B3B3;
              }

              &::after {
                content: "";
                position: absolute;
                left: 2px;
                top: .12rem;
                width: 1px;
                height: 1.74rem;
                background: #B3B3B3;
              }

              &:last-of-type::after {
                display: none;
              }

              span {
                margin-right: .16rem;
              }

              big {
                display: block;
                font-size: .24rem;
                color: #403C3B;
                font-family: sybold;
                flex: 1;
                background: linear-gradient(to right, RGBA(219, 227, 237, 1) 0%, RGBA(225, 221, 237, 1) 100%);
                padding: .18rem .16rem;
                border-radius: .04rem;
                line-height: .38rem;
                margin-top: .12rem;

                span {
                  &:first-child {
                    font-size: .26rem;
                    margin-right: 0;
                  }

                  &:last-child {
                    margin-right: 0;
                    color: #736B69;
                  }
                }
              }
            }
          }
        }
      }
    }
    .dialog-close {
      position: absolute;
      bottom: -1.04rem;
      left: 50%;
      transform: translateX(-50%);
      width: .8rem;
      height: .8rem;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/speakersDialog.vue